import { render, staticRenderFns } from "./TokenDetail.vue?vue&type=template&id=285c470a"
import script from "./TokenDetail.vue?vue&type=script&lang=js"
export * from "./TokenDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports